import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import {
  getNotificaciones,
  createNotificacion,
  editNotificacion,
} from "../../Services/notificaciones_service";
import { TOAST_DELAY } from "../../Constantes/constants";

const initialState = {
  notificaciones: [],
  notificacion: {
    idNotificacion: 0,
    nombre: "",
    titulo: "",
    descripcion: "",
    icono: "",
    idPlantilla: null,
    fechaProgramada: null,
    fechaExpiracion: null,
    tipoAudiencia: "",
    valorAudiencia: null,
    filtroAudiencia: null,
    estado: true,
    usuario: "",
  },
  notificacionesSeleccionadas: [],
};

export const notificacionesSlice = createSlice({
  name: "notificaciones",
  initialState,
  reducers: {
    setNotificaciones: (state, action) => {
      state.notificaciones = action.payload;
    },
    setNotificacion: (state, action) => {
      state.notificacion = !action.payload
        ? initialState.notificacion
        : action.payload;
    },
    setNotificacionesSeleccionadas: (state, action) => {
      state.notificacionesSeleccionadas = action.payload;
    },
  },
});

export const fetchNotificaciones = createAsyncThunk(
  "notificaciones/fetchNotificaciones",
  async (_, { dispatch }) => {
    const notificacionesRes = await getNotificaciones();
    dispatch(setNotificaciones(notificacionesRes));
  }
);

export const addNotificacion = createAsyncThunk(
  "notificaciones/create",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const notificacionRes = await createNotificacion(data);
    dispatch(setResponse(notificacionRes));
    dispatch(setLoading(false));
    
    if (Boolean(notificacionRes.result)) {
      dispatch(setModal(false));
      dispatch(fetchNotificaciones());
    }
    
    dispatch(setToast(true));
    setTimeout(() => {
      dispatch(setToast(false));
    }, TOAST_DELAY);
  }
);

export const editNotificacionThunk = createAsyncThunk(
  "notificaciones/update",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const notificacionRes = await editNotificacion(data);
    dispatch(setResponse(notificacionRes));
    dispatch(setLoading(false));
    
    if (Boolean(notificacionRes.result)) {
      dispatch(setModal(false));
      dispatch(fetchNotificaciones());
    }
    
    dispatch(setToast(true));
    setTimeout(() => {
      dispatch(setToast(false));
    }, TOAST_DELAY);
  }
);

export const { setNotificaciones, setNotificacion, setNotificacionesSeleccionadas } =
  notificacionesSlice.actions;
export default notificacionesSlice.reducer;